import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'

const viewSelector = state => state.ui.currentView
const gameSelector = state => state.game.canReplace
const drawitSelector = state => state.drawIt.canReplace
const matchingPairsSelector = state => state.matchingPairsCt.canReplace

const canReplaceSelector = createSelector(
	[
		viewSelector,
		gameSelector,
		drawitSelector,
		matchingPairsSelector,
	],
	(view, gameFlag, drawItFlag, matchingPairsFlag) => {

		const viewToflagMap = {
			[viewTypes.TIME_TO_CLIMB_CREATION]: gameFlag,
			[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: matchingPairsFlag,
			[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: gameFlag,
			[viewTypes.DRAW_IT_CREATION]: drawItFlag,
			[viewTypes.DRAW_IT_STANDALONE_CREATION]: drawItFlag,
			[viewTypes.MATCHING_PAIRS_CREATION]: matchingPairsFlag,
		}

		return viewToflagMap[view]
	}
)

export default canReplaceSelector
